/*
 * @Author: 秦少卫 nihaojob@163.com
 * @Date: 2025-05-14 15:04:07
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-06 10:56:04
 * @FilePath: /kuaitu/src/router/adminRoutes.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { RouteRecordRaw } from 'vue-router';

// import { setToken, autoLogin, logout } from '@/api/user';
// import Layout from '@/views/admin/index.vue';
import Layout from '@/views/admin/index.vue';
const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: () => import('@/views/admin/login/index.vue'),
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/welcome',
    children: [
      // 店铺管理
      {
        path: 'shopManage',
        component: () => import('@/views/admin/shopManage/index.vue'),
      },
      // 用户金币管理
      {
        path: 'userCoinManage',
        component: () => import('@/views/admin/userCoinManage/index.vue'),
      },
      // 店铺订单管理
      {
        path: 'shopOrderManage',
        component: () => import('@/views/admin/shopOrderManage/index.vue'),
      },
      {
        path: 'userManage',
        component: () => import('@/views/admin/userManage/index.vue'),
      },
      {
        path: 'userAgreement',
        component: () => import('@/views/admin/userAgreement.vue'),
      },
      {
        path: 'welcome',
        component: () => import('@/views/admin/welcome/index.vue'),
      },
      {
        path: 'tempTypeManage',
        component: () => import('@/views/admin/tempTypeManage.vue'),
      },
      {
        path: 'materialTypeManage',
        component: () => import('@/views/admin/materialTypeManage.vue'),
      },
      {
        path: 'fontsTypeManage',
        component: () => import('@/views/admin/fontstyleTypeManage.vue'),
      },
      {
        path: 'materialManage',
        component: () => import('@/views/admin/materialManage.vue'),
      },
      {
        path: 'canvasSizeManage',
        component: () => import('@/views/admin/canvasSizeManage.vue'),
      },
      {
        path: 'bannerManage',
        component: () => import('@/views/admin/bannerManage.vue'),
      },
      {
        path: 'noticeManage',
        component: () => import('@/views/admin/noticeManage.vue'),
      },
      {
        path: 'logo',
        component: () => import('@/views/admin/logo.vue'),
      },
      {
        path: 'tempManage',
        component: () => import('@/views/admin/tempManage.vue'),
      },
      {
        path: 'fontstyleManage',
        component: () => import('@/views/admin/fontstyleManage.vue'),
      },
      {
        path: 'fontborderManage',
        component: () => import('@/views/admin/fontborderManage.vue'),
      },
      {
        path: 'fontManage',
        component: () => import('@/views//admin/fontManage.vue'),
      },
      {
        path: 'userMaterial',
        component: () => import('@/views/admin/userMaterial.vue'),
      },
      {
        path: 'userTempl',
        component: () => import('@/views/admin/userTempl.vue'),
      },
      {
        path: 'userFont',
        component: () => import('@/views/admin/userFont.vue'),
      },
      {
        path: 'userComponent',
        component: () => import('@/views/admin/userComponent.vue'),
      },
      {
        path: 'backgroundType',
        component: () => import('@/views/admin/backgroundType.vue'),
      },
      {
        path: 'backgroundManage',
        component: () => import('@/views/admin/backgroundManage.vue'),
      },
      {
        path: 'vipconfigManage',
        component: () => import('@/views/admin/vipconfigManage.vue'),
      },
      {
        path: 'vipUserManage',
        component: () => import('@/views/admin/vipUserManage.vue'),
      },
      {
        path: 'commodiyManage',
        component: () => import('@/views/admin/commodiyManage/index.vue'),
      },
      {
        path: 'commodiytypeManage',
        component: () => import('@/views/admin/commodiyManage/type.vue'),
      },
      {
        path: 'commodiyProTypeManage',
        component: () => import('@/views/admin/commodiyManage/proType.vue'),
      },
      {
        path: 'commodiyorderManage',
        component: () => import('@/views/admin/commodiyManage/order.vue'),
      },
      {
        path: 'commodiyTemplate',
        component: () => import('@/views/admin/commodiyManage/template.vue'),
      },
      {
        path: 'aiStyleManage',
        component: () => import('@/views/admin/aiStyleManage.vue'),
      },
      {
        path: 'rechargeManage',
        component: () => import('@/views/admin/rechargeManage.vue'),
      },
      {
        path: 'meterialQualityManage',
        component: () => import('@/views/admin/meterialQualityManage/index.vue'),
      },
      {
        path: 'filmCoverManage',
        component: () => import('@/views/admin/filmCoverManage/index.vue'),
      },
      {
        path: 'renderingMaterialManagement',
        component: () => import('@/views/admin/renderingMaterialManagement/index.vue'),
      },
      {
        path: 'normalMaterial',
        component: () => import('@/views/admin/normalMaterial/index.vue'),
      },
      {
        path: 'outsideComponentsManage',
        component: () => import('@/views/admin/outsideComponentsManage/index.vue'),
      },
      {
        path: 'DfbgImgManage',
        component: () => import('@/views/admin/DfbgImgManage/index.vue'),
      },
      {
        path: 'DfSizeManage',
        component: () => import('@/views/admin/DfSizeManage/index.vue'),
      },
      {
        path: 'DfCommodityManage',
        component: () => import('@/views/admin/DfCommodityManage/index.vue'),
      },
      {
        path: 'attriButes',
        component: () => import('@/views/admin/attriButes/index.vue'),
      },
      {
        path: 'attriButesValue',
        component: () => import('@/views/admin/attriButes/attributeValue.vue'),
      },
      {
        path: 'skuConfig',
        component: () => import('@/views/admin/commodiyManage/skuConfig.vue'),
      },
      {
        path: 'h5banner',
        component: () => import('@/views/admin/h5banner/index.vue'),
      },
    ],
  },
];

export default routes;
